export const PAGE_TITLE = "Business and Practice Management";

export const PAGE_TEXT =
  "At the <b>Institute of Interpersonal Hypnotherapy (IIH)</b>, we are committed to supporting graduates not only in mastering transformational techniques but also in establishing a strong foundation for a successful career in hypnotherapy. This page provides essential resources to help students and graduates navigate the practicalities of managing their businesses.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1AC3v-9wmZNhPeIa1Bs1khAihJYAAIhM6/preview";

export const SECTION_TITLE = "Key areas of focus include:";

export const SUCCESS_MESSAGE = "Data saved successfully";

export const ERROR_MESSAGE = "Failed to save the data";

export const API_ENDPOINT = "user/businessPractice-checklist";

export const CHECKLIST_SKIP_KEYS = [
  "id",
  "userId",
  "createdAt",
  "updatedAt",
];

export const FOOTER_TEXT =
  "These resources are designed to empower you to build and sustain a thriving hypnotherapy practice. Take advantage of them to set yourself up for long-term success!";
